import { useSplitTreatments } from "@splitsoftware/splitio-react";
import featureFlags from "../constants/feature-flags.json";
export var FEATURE_FLAGS = featureFlags;
export var useFeatureToggle = function(flagName) {
    var isMock = import.meta.env.MODE !== "production" || import.meta.env.VITE_MOCK;
    var _useSplitTreatments = useSplitTreatments({
        names: [
            flagName
        ]
    }), isReady = _useSplitTreatments.isReady, treatments = _useSplitTreatments.treatments;
    if (isMock) {
        return [
            true
        ];
    }
    if (!isReady) {
        return [
            undefined
        ];
    }
    return [
        treatments[flagName].treatment === "on"
    ];
};

//# sourceMappingURL=useFeatureToggle.js.map